import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  typedWord = '';

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Object,
    private translate: TranslateService) { }

  ngOnInit() {
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public accept() {
    if (this.canAccept()) {
      this.dialogRef.close(true);
    }
  }

  public get requiredWord(): string {
    const key = this.data['requiredWordKey'];
    return key ? this.translate.instant(key) : '';
  }

  public canAccept(): boolean {
    const key = this.data['requiredWordKey'];
    return !key || (this.requiredWord !== key && this.typedWord.trim() === this.requiredWord);
  }

}
